module.exports = __webpack_public_path__ + "img/00038.b7c5dae5.webp";